




























import { PropType, defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'CalendarDropdown',

  inheritAttrs: true,

  props: {
    value: {
      type: [] as PropType<string | string[]>,
      default: undefined
    }
  },

  setup(props, { emit }) {
    const openCalendar = ref(false)
    const internalDates = ref<string | string[] | undefined>()

    const onCalendarDropdownStateChange = () => (internalDates.value = props.value)

    const onConfirm = () => {
      emit('input', internalDates.value)
      internalDates.value = undefined
      openCalendar.value = false
    }

    const onCancel = () => {
      openCalendar.value = false
      internalDates.value = undefined
    }

    return {
      openCalendar,
      internalDates,
      onCalendarDropdownStateChange,
      onConfirm,
      onCancel
    }
  }
})
